import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ICategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/ICategoriaHipoModel';
import { IFilterCategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/IFilterCategoriaHipoModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoriaHipoService {

  private configUrl = [environment.apiGatewayUrl, 'categorias-hipo'].join('/');
  constructor(private http: HttpClient) { }

  getListFiltered(
    model: IFilterCategoriaHipoModel
    ) : Observable<SearchResultModel<ICategoriaHipoModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);
    
    if (model.nombre !== '') {
      queryParams.push(`nombre=${model.nombre}`);
    }

    return this.http.get<SearchResultModel<ICategoriaHipoModel[]>>(
      `${this.configUrl}/filtrar?${queryParams.join('&')}`
    );
  }

  getAllList(
    model: IFilterCategoriaHipoModel
    ) : Observable<ICategoriaHipoModel[]> {
    let queryParams: string[] = new Array<string>();

    // queryParams.push(`page=${model.page}`);
    // queryParams.push(`take=${model.pageSize}`);

    return this.http.get<ICategoriaHipoModel[]>(
      `${this.configUrl}/all?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<ICategoriaHipoModel> {
    return this.http.get<ICategoriaHipoModel>(`${this.configUrl}/${id}`);
  }

  submit(model: ICategoriaHipoModel) {
    return this.http.post<ICategoriaHipoModel>(`${this.configUrl}`, model);
  }

  update(model: ICategoriaHipoModel) {
    return this.http.put<ICategoriaHipoModel>(
      `${this.configUrl}/${model.idCategoriaHipo}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<ICategoriaHipoModel>(`${this.configUrl}/${id}`);
  }
}
